/*
 * Copyright (C) Luna Srl - All Rights Reserved
 *
 * @project    bfree-frontend.nosync
 * @file       PhoneVerificationImage.tsx
 * @author     Christian Ascone
 * @date       10/9/19 4:05 PM
 */

import React from 'react';
import {Image} from "react-native";

export function PhoneVerificationImage(props) {
    return (
        <Image
            {...props}
            style={[props.style, {resizeMode: 'contain',}]}
            source={
                require('../../assets/images/phone_verification.png')
            }
        />
    );
}